var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-divider-plus u-position-relative d-flex align-center justify-center",style:({ height: _vm.height })},[_c('IconPlus',{staticClass:"gst-divider-plus__icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }